import axios from 'axios';
import { City } from '../types/city';

import { API_URL } from '../config/api';

export const cityService = {
    getAll: async (): Promise<City[]> => {
        const response = await axios.get(`${API_URL}/cities`);
        return response.data;
    },

    create: async (city: Omit<City, 'id' | 'createdAt' | 'updatedAt'>, userEmail: string): Promise<City> => {
        const response = await axios.post(`${API_URL}/cities`, {
            ...city,
            userEmail,
        });
        return response.data;
    },

    update: async (id: string, city: Omit<City, 'id' | 'createdAt' | 'updatedAt'>, userEmail: string): Promise<City> => {
        const response = await axios.put(`${API_URL}/cities/${id}`, {
            ...city,
            userEmail,
        });
        return response.data;
    },

    delete: async (id: string, userEmail: string): Promise<void> => {
        await axios.delete(`${API_URL}/cities/${id}`, {
            data: { userEmail },
        });
    },
};
